<template>
<div>
  <layout-header id="layoutHeader"></layout-header>
  <sub-title id="layoutSubTitle" title="最新视频" en-title="Latest Videos"></sub-title>
  <login-tips-bar id="loginTipsBar" v-if="loginStatus" tips-text="如需下载高清视频"></login-tips-bar>
  <tags-search-bar v-if="tagList.length" :list="tagList"
                   id="tagsSearchBar"
                   @search="resetSearch"></tags-search-bar>
  <div class="layout-content" :style="{'top': topHeight + 'px'}">
    <videos-list :list="list"></videos-list>
    <infinite-loading @infinite="infiniteHandler"
                      ref="infiniteLoading"
                      :identifier="identifierRefresh">
      <span slot="spinner"></span>
      <span slot="no-more"></span>
      <div class="news-list-nodata" slot="no-results">
        <p>暂无数据</p>
      </div>
    </infinite-loading>
  </div>
</div>
</template>

<script>
import LayoutHeader from "@/layout/MediaCenter/components/LayoutHeader";
import VideosList from "../../components/MediaCenter/VideosList";
import apiMc from "@/api/MediaCenter";
import InfiniteLoading from 'vue-infinite-loading';
import LoginTipsBar from "../../components/MediaCenter/LoginTipsBar";
import TagsSearchBar from "../../components/MediaCenter/TagsSearchBar";
import SubTitle from "@/components/MediaCenter/SubTitle";

const PARAMS = {
  pageNum: 0,
  pageSize: 10,
  newsType: 5,
  tagId: 0
}
export default {
  name: "VideosDownload",
  components: {
    SubTitle,
    TagsSearchBar,
    LoginTipsBar,
    VideosList,
    LayoutHeader,
    InfiniteLoading
  },
  data() {
    return {
      list: [],
      tagList: [],
      params: Object.assign({},PARAMS),
      identifierRefresh: +Date.now(),
      topHeight: 65 + 45
    }
  },
  created() {
  },
  computed: {
    loginStatus() {
      return localStorage.getItem('dUserToken') === null
    }
  },
  methods: {
    async infiniteHandler($state) {
      this.$loading.show();
      const data = await this.getRows({
        offset: this.params.pageNum * this.params.pageSize,
        limit: this.params.pageSize,
        newsType: this.params.newsType,
        tagId: this.params.tagId
      })
      const newList = this.formatRows(data.rcclNews);
      this.getTagsList(newList);
      if (newList.length > 0) {
        this.list = [...this.list, ...newList];
        this.params.pageNum++;
        $state.loaded()
      } else {
        $state.complete()
      }
      this.$loading.hide()
    },
    async getRows({ offset, limit, newsType, tagId }) {
      const { success, data, errMsg } = await apiMc.newsFileList.getNews({offset, limit, newsType, tagId});
      if (success) {
        return data;
      } else {
        console.log(errMsg)
        return null;
      }
    },
    formatRows(rows) {
      rows && rows.forEach((row)=>{
        row.isFold = false;
      });
      return rows;
    },
    getTagsList(rows) {
      rows && rows.forEach((row)=>{
        let fileItemTags = row.fileItemTags;
        this.tagList.push(...fileItemTags);
      });
      this.tagList = this.tagList.filter((element,index,self)=>{
        return self.findIndex(x=>x.tagId===element.tagId) === index;
      });
      setTimeout(()=>{this.getTopHeight()},100)
    },
    resetSearch(val) {
      this.params = Object.assign({},PARAMS);
      this.params.tagId = val.tagId;
      this.list = [];
      // this.tagList = [];
      this.identifierRefresh = +Date.now();
    },
    getTopHeight() {
      let layoutHeader = document.getElementById("layoutHeader");
      let layoutSubTitle = document.getElementById("layoutSubTitle");
      let loginTipsBar = document.getElementById("loginTipsBar");
      let tagsSearchBar = document.getElementById("tagsSearchBar");
      this.topHeight = 0;
      if(layoutHeader){
        this.topHeight += layoutHeader.offsetHeight;
      }
      if(layoutSubTitle) {
        this.topHeight += layoutSubTitle.offsetHeight;
      }
      if(loginTipsBar) {
        this.topHeight += loginTipsBar.offsetHeight;
      }
      if(tagsSearchBar) {
        this.topHeight += tagsSearchBar.offsetHeight;
      }
    }
  }
}
</script>

<style scoped>

</style>
